import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowUndoneSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.914 6H8.5a1.5 1.5 0 1 1 0 3H8v1h.5a2.5 2.5 0 1 0 0-5H2.914l2.293-2.293L4.5 2 1 5.5 4.5 9l.707-.707L2.914 6Z"
    />
  </svg>
);
export default IconArrowUndoneSizeXs;
